import { createAsyncThunk } from "@reduxjs/toolkit";
import { getPrograms, getProgramById } from "api/programs.api";

export const getProgramsAsync = createAsyncThunk(
  "programs/get-all",
  async () => {
    const programs = await getPrograms();
    return programs;
  }
);

export const getProgramByIdAsync = createAsyncThunk(
  "programs/get-by-id",
  async (id) => {
    const program = await getProgramById(id);
    const response = await fetch(program.content);
    const text = await response.text();
    return { ...program, content: text };
  }
);
